// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__Jf60i"};